// Videos oficiales de XIMA para la pestaña «Videos» de Aprender (2026-10-18, pedido de Yosdel).
// Solo se guardan enlaces y miniaturas: ningún video se descarga ni se sube al servidor, y el
// reproductor se carga solo cuando alguien toca un video. Se dejó fuera el audiolibro de 3 horas.
// TikTok sin sesión solo deja ver los 13 más recientes (los 3 primeros son los fijados del perfil).
// Lista sacada de los canales el 2026-10-18; para añadir uno nuevo basta con ponerlo arriba de su lista.

// Las miniaturas de TikTok están en public/assets/learn-videos (carpeta que no se renombra al compilar).

export const TIKTOK_VIDEOS = [
  { id: "7685513970005921037", thumb: "/assets/learn-videos/tt-7685513970005921037.webp", title: { es: "Cómo jugar XIMA", en: "How to play XIMA" } },
  { id: "7682884040478723341", thumb: "/assets/learn-videos/tt-7682884040478723341.webp", title: { es: "El nuevo juego XIMA", en: "The new XIMA game" } },
  { id: "7675872945293577486", thumb: "/assets/learn-videos/tt-7675872945293577486.webp", title: { es: "Puzzle 8, día 1 (intento 4 de 5)", en: "Puzzle 8, day 1 (try 4 of 5)" } },
  { id: "7692141792161975565", thumb: "/assets/learn-videos/tt-7692141792161975565.webp", title: { es: "XIMA en juegoxima.com", en: "XIMA on juegoxima.com" } },
  { id: "7691165995733454094", thumb: "/assets/learn-videos/tt-7691165995733454094.webp", title: { es: "Pierdo de nuevo con «el mejor del mundo»", en: "I lose again to “the best in the world”" } },
  { id: "7691164276072992014", thumb: "/assets/learn-videos/tt-7691164276072992014.webp", title: { es: "Felicidades, hermanito", en: "Congrats, little brother" } },
  { id: "7691119036289109261", thumb: "/assets/learn-videos/tt-7691119036289109261.webp", title: { es: "El tablero físico de XIMA", en: "The physical XIMA board" } },
  { id: "7690346804684016910", thumb: "/assets/learn-videos/tt-7690346804684016910.webp", title: { es: "Un juego de mesa para la familia", en: "A board game for the family" } },
  { id: "7690295540650691853", thumb: "/assets/learn-videos/tt-7690295540650691853.webp", title: { es: "XIMA, un juego novedoso", en: "XIMA, a brand-new game" } },
  { id: "7690020372791430413", thumb: "/assets/learn-videos/tt-7690020372791430413.webp", title: { es: "XIMA es divertido", en: "XIMA is fun" } },
  { id: "7689965151134534925", thumb: "/assets/learn-videos/tt-7689965151134534925.webp", title: { es: "Lo mejor del directo", en: "Live highlights" } },
  { id: "7689964099999960334", thumb: "/assets/learn-videos/tt-7689964099999960334.webp", title: { es: "En directo con un seguidor", en: "Live with a follower" } },
  { id: "7689879689854323982", thumb: "/assets/learn-videos/tt-7689879689854323982.webp", title: { es: "Nuevo juego: XIMA", en: "New game: XIMA" } },
];

export const YOUTUBE_ES_SHORTS = [
  { id: "sWzIX0DGQo8", title: "octubre 2, 2026" },
  { id: "H1Ts206nb-U", hq: true, title: "pierdo de nuevo" },
  { id: "1uVRW56xcqI", hq: true, title: "felicidadez hermanito" },
  { id: "Rwh8QLvd0Co", title: "Al ritmo de la musica" },
  { id: "bG2H6K8aDaY", title: "septiembre 27, 2026" },
  { id: "qZCpedl6vRk", title: "septiembre 27, 2026" },
  { id: "HLKC8JuS1bY", title: "Ya está listo el nuevo juego físico del juego Xima" },
  { id: "Ry-sKLv3YW0", title: "septiembre 26, 2026" },
  { id: "qpzaBcxwhFc", title: "Juego entre mi amigo Carlos y yo de mesa juego" },
  { id: "pNBCedklc2A", hq: true, title: "El juego ciencia más facil del mundo" },
  { id: "JiWq-blnsEg", hq: true, title: "COMO JUGAR XIMA" },
  { id: "LhqkmKw7Quw", title: "Gran premio de 100 USD" },
  { id: "0eHU3utnpzs", hq: true, title: "JOSE Y YOSDEL REPLAY" },
  { id: "bQWpFyNXoyU", title: "XIMA NUEVO JUEGO GRATIS" },
  { id: "xu8pF6M6Iho", hq: true, title: "Hombre vs Bot ¡El Desafío Comienza!" },
  { id: "SmODqgQQY9k", title: "Estrategia Clave ¡El Salto a la Cima!" },
  { id: "vTMx0NGQHbs", hq: true, title: "Juego Cima ¡Así se Mueven las Piezas!" },
  { id: "y5dbz7425cU", title: "Al Bot le Falta Agallas para Ganar" },
  { id: "1--MCtXSgmg", title: "¡El Lanzamiento de la Victoria!" },
  { id: "8BeqRBfZFyI", hq: true, title: "Solucion del puzzle 5 modo ciencia del juego xima" },
  { id: "FqYsZzZUhA0", hq: true, title: "Solucion del puzzle 4 modo ciencia del juego xima" },
  { id: "vHzfLdF0LhI", hq: true, title: "tercer puzzle modo ciencia del juego xima" },
  { id: "qKDFuJxwovk", hq: true, title: "segundo puzzle ciencia del juego xima" },
  { id: "RUT-dNO0D-U", hq: true, title: "resuelvo el puzzle 3d de cima modo ciencia" },
  { id: "Cy08Psyd-MY", title: "XIMA SE PARECE A LA VIDA" },
  { id: "CxSan4YmN1Y", title: "El BOT me gana jugando por control de voz" },
  { id: "Ehb2qAZOeVQ", hq: true, title: "Resumen del control de voz para un juego de xima" },
  { id: "7YJwQHnMez0", hq: true, title: "segundo intento dia 6 puzzle 8 de azar" },
  { id: "HXF3Yya96l4", hq: true, title: "primer intento dia 6 puzzle 8 azar" },
  { id: "2Ptpa611ZLY", hq: true, title: "FRACASO 25" },
  { id: "CCw5laESoSs", hq: true, title: "FRACASO 24" },
  { id: "0x0u3CFgjeg", hq: true, title: "FRACASO 23" },
  { id: "2chZgFAgtwE", title: "FRACASO 22" },
  { id: "UfI-H9CR0Yg", hq: true, title: "puzzle 8 resuelto" },
  { id: "88dZerzo740", title: "FRACASO 21" },
  { id: "S333XoqLq4Y", title: "El plan ideal para la apertura" },
  { id: "YgB-TcmFGGs", title: "Evita crear debilidades" },
  { id: "HT56Dr-sX0I", hq: true, title: "Lo segundo en cuenta en un juego de Xima" },
  { id: "-sip2jLx-m0", title: "el plan mas sencillo juegoxima" },
  { id: "2EgYsTO8_cM", title: "COMO SUBIR DE PRIMERO SIEMPRE" },
  { id: "LHTurpdNpJw", hq: true, title: "dia 4 intento 3" },
  { id: "9sESlpaaZcE", hq: true, title: "dia 4 intento 5" },
  { id: "43pZ01aDbSk", title: "Dia 4 intento 4" },
  { id: "RjJRhXmkkYk", hq: true, title: "3 como jugar xima desde un minuto" },
  { id: "eTnCytkMtdE", hq: true, title: "Dia 4 intento 2 denuevo" },
  { id: "e1RKBQKGACI", hq: true, title: "Dia 4 intento 1" },
  { id: "OE6zyYpmfgk", hq: true, title: "EL PROXIMO CAMPEON" },
  { id: "2cxbWqxfgo4", hq: true, title: "DIA 3 INTENTO 5" },
  { id: "6eyL6gcGhvY", hq: true, title: "DIA 3 INTENTO 4" },
  { id: "YoXzy9W_GoM", hq: true, title: "DIA 3 INTENTO 3" },
  { id: "qT5N5lnVp1Y", hq: true, title: "DIA 3 INTENTO 2" },
  { id: "yGlfvOhxHVc", hq: true, title: "DIA 3 INTENTO 1" },
  { id: "bntr9-JIfsQ", hq: true, title: "GANA EN 2 MOVIMIENTOS" },
  { id: "sqTh5DxjfcQ", hq: true, title: "en el siguiente turno gana el o yo" },
  { id: "foCKFkRcPgE", hq: true, title: "último intento del dia 2" },
  { id: "c8UMOC9ajxs", hq: true, title: "Dia 2 intento 4" },
  { id: "zBa2Tfjgb9o", hq: true, title: "Día 2 intento 3 del puzzle numero 8" },
  { id: "5fE2fDCpmBM", hq: true, title: "dia 2 intento 2 azar" },
  { id: "14FIaTNDWuc", hq: true, title: "Día 2 intento 1" },
  { id: "tcSbTKx6N1Y", hq: true, title: "Dia 1 resolviendo el puzzle 8 modo Azar del juego Xima intento 5" },
  { id: "lJGdLRdu0y8", hq: true, title: "Dia 1 resolviendo el puzzle 8 modo Azar del juego Xima intento 4" },
  { id: "5JUk8lqZpbs", hq: true, title: "Dia 1 resolviendo el puzzle 8 modo Azar del juego Xima intento 3" },
  { id: "HPN29FiVQro", hq: true, title: "Dia 1 resolviendo el puzzle 8 modo Azar del juego Xima intento 2" },
  { id: "5rToOXuHwPk", hq: true, title: "Dia 1 resolviendo el puzzle 8 modo Azar del juego Xima" },
  { id: "WoQuQuCNfVk", title: "La mejor app para aprender a jugar ajedrez Caissa novel Chess" },
];

export const YOUTUBE_ES_VIDEOS = [
  { id: "GX2u0JyHTpU", title: "COMO REGISTRARME EN UNA PAGINA WEB DEL JUEGO XIMA", duration: "1:04" },
  { id: "w3UqxBIRkUo", title: "EL NUEVO JUEGO XIMA", duration: "0:21" },
  { id: "f8cDjovj_3U", title: "YO CONTRA DOS BOT", duration: "8:17" },
  { id: "PR44_VFmVJ4", title: "JUEGO CONTRA 1 BOT 5 MINUTOS", duration: "5:02" },
  { id: "qPLIjoAmPwk", title: "Ya el juego xima se puede jugar por contol de voz", duration: "7:30" },
  { id: "PE11rddhbBs", title: "SOLUCION FINAL DEL PUZZLE NUMERO 8 DE AZAR", duration: "1:56" },
  { id: "m1qTcYXZyQI", title: "COMO JUGAR XIMA POR CONTROL DE VOZ", duration: "9:41" },
  { id: "QRlqJOmIeSI", title: "21,22,23,24 y 25 fracasos continuos", duration: "3:19" },
  { id: "2DxbvtET37M", title: "como entrar y jugar en un torneo online del juego Xima", duration: "2:13" },
  { id: "PZbMmbht8ow", title: "COMO SUBIR DE PRIMERO", duration: "1:59" },
  { id: "pzYAK15XEu4", title: "Dia 4 resolviendo el puzzle de azar 8", duration: "3:13" },
  { id: "u-lZyEN7yAY", title: "DIA 3 PUZZLE AZAR", duration: "3:25" },
  { id: "6w2oHI8xM2U", title: "Como prefieres jugar modo ciencia o azar", duration: "15:00" },
  { id: "mHVs2nemK8g", title: "DIA 2 resolviendo el puzzle 8", duration: "3:29" },
  { id: "Wt_xcWd1XvE", title: "DIA 1 PUZZLE 8", duration: "5:55" },
  { id: "RuEOgo52QnY", title: "No cometas este error, juego xima", duration: "9:27" },
  { id: "u1-SU_1eTp0", title: "Juego de Xima modo ciencia contra mi amigo Adrian", duration: "7:54" },
  { id: "_9HTAXxFLwQ", title: "Tutorial del juego Xima y su nueva pagina web", duration: "5:16" },
  { id: "6XjKtO0NI0g", title: "BOT GANA SU PRIMER JUEGO DE XIMA", duration: "3:03" },
  { id: "3ORU2lL7EiU", title: "Cienzar", duration: "2:30" },
  { id: "DoEsqedZh1M", title: "Como usar un bloque escalera", duration: "2:54" },
  { id: "Vl_kDE37tZ0", title: "Captura en el juego xima", duration: "1:50" },
  { id: "qayKtxykyyE", title: "Control total de la columna D", duration: "2:12" },
  { id: "rrSxNTxoBuk", title: "Características del tablero del juego Xima", duration: "2:00" },
  { id: "WhEmFfpDAEA", title: "Entrena tu mente", duration: "1:25" },
  { id: "yCFNBLTMaf0", title: "Objetivo del juego xima", duration: "0:55" },
  { id: "8p-Hyx1nPE0", title: "video de explicación de la dominación en español", duration: "1:39" },
  { id: "uPO4Gvelwjk", title: "cienzar", duration: "1:09" },
  { id: "g-76SnL-xEk", title: "Juego en la web con Adrian", duration: "4:56" },
  { id: "Aaduagx5F4I", title: "Juego con Carlos", duration: "2:07" },
  { id: "oEKw25TaYbs", title: "Primer juego de Xima con mi hijo de 9 años", duration: "2:17" },
  { id: "12Bzy63sUKE", title: "10 caracteristísticas únicas del juego Xima", duration: "0:58" },
  { id: "K7_ZI4w6OAs", title: "juego fisico Xima", duration: "0:50" },
  { id: "Fmbw5MbIqSk", title: "como jugar xima online", duration: "2:05" },
  { id: "t44Bej905Dk", title: "Caissa novel chess", duration: "1:04" },
  { id: "0V2S2e6H8Cc", title: "MANIOBRA fINALES ELEMENTALES DE CIMA", duration: "1:59" },
  { id: "-yQI1hJn9FU", title: "MANIOBRA Zil", duration: "2:56" },
  { id: "YmFT9-M4NlM", title: "MANIOBRA Fitbak", duration: "2:56" },
  { id: "rL8jNYETd_o", title: "VALORACION DE UNA PARTIDA", duration: "2:01" },
  { id: "qURQhwfa9xc", title: "SISTEMA DE NOTACION", duration: "1:31" },
  { id: "sq7K8kRUxno", title: "COMO DOMINAR Y CAPTURAR EN LA XIMA", duration: "1:46" },
  { id: "RhLjj35L-bY", title: "COMO SUBIR Y BAJAR EN LA XIMA", duration: "2:19" },
  { id: "t1bPRuXno0I", title: "INCORPORACION Y MOVIMIENTO EN LA XIMA", duration: "1:59" },
  { id: "WptQ6NPngOg", title: "OBJETIVO Y MECANICA DEL JUEGO XIMA", duration: "1:29" },
];

export const YOUTUBE_EN_SHORTS = [
  { id: "orXDrfOSdDs", title: "Best app for chess learning Caissa: Novel Chess" },
];

export const YOUTUBE_EN_VIDEOS = [
  { id: "J8ibcFXXahM", title: "Cienzar, How to play it?", duration: "2:33" },
  { id: "ITHBiDyRH_Q", title: "cienzar", duration: "1:09" },
  { id: "2vvBJ256Bxg", title: "How to incorporate and move in the Xima game", duration: "1:42" },
  { id: "K-ChPEHJhIg", title: "How to move up and down in the Xima game", duration: "2:11" },
  { id: "mUtwTULvnRs", title: "Gameplay Mechanics of the Game Xima.", duration: "0:11" },
  { id: "gygxioRCY-8", title: "How to assemble a board for the Xima game", duration: "0:32" },
];

export const LEARN_VIDEOS_TOTAL =
  TIKTOK_VIDEOS.length +
  YOUTUBE_ES_SHORTS.length +
  YOUTUBE_ES_VIDEOS.length +
  YOUTUBE_EN_SHORTS.length +
  YOUTUBE_EN_VIDEOS.length;
